import { Post, User } from '@wellesley/openapi'
import { getDisplayUsername } from '@wellesley/user'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

export const getReplyFeedTitle = (feed?: Post | null) =>
  `<span class="text-gray-900 font-semibold">${feed?.author.displayName}</span> <span class="text-gray-500 font-medium">${getDisplayUsername(getUserNameWithDomain(feed?.author as User))}</span>`

export const getReplyFeedSubtitle = (feed?: Post | null) =>
  `<span class='text-gray-500 font-normal'>replied to</span> <span class='text-gray-900 font-semibold'>${feed?.author.displayName}</span> <span class='text-gray-500'>${getDisplayUsername(getUserNameWithDomain(feed?.author as User))}</span>`

export const getPublisherTitle = (feed?: Post | null) =>
  `<span class="text-gray-900 font-semibold">${getDisplayUsername(getUserNameWithDomain(feed?.author as User))}</span> <span class="text-gray-500 font-medium">${feed?.author.username}</span>`

export const getPublisherSubtitle = (feed?: Post | null) =>
  `<span class='text-gray-500 font-normal'>posted in</span> <span class='text-gray-900 font-semibold'>${feed?.publisher?.displayName}</span>`
